<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  /**
   * The name of the icon to display.
   * @type {string}
   */
  export let icon = 'help-circle';

  /**
   * Translation key for the heading text.
   * @type {string}
   */
  export let heading = '';

  /**
   * Translation key for the description text.
   * @type {string}
   */
  export let description = '';

  /**
   * Translation key for the call-to-action button label.
   * @type {string}
   */
  export let action = '';
</script>

<div class="empty-state">
  <div class="empty-message">
    <div class="empty-icon">
      <Icon name={icon} />
    </div>
    <h3>{$format(heading)}</h3>
    <p>{$format(description)}</p>
    <Button color="primary" on:click>
      {$format(action)}
    </Button>
  </div>
</div>

<style lang="scss" src="./empty-state.scss"></style>
